export default "__VITE_ASSET__BozufZdK__"